module.exports = __webpack_public_path__ + "static/media/reply-icon.407a24e7.svg";